/**
 * Accessible FAQ Accordion Module
 */
(function() {
  'use strict';

  function initAccordion() {
    const accordionTriggers = document.querySelectorAll('.accordion-trigger');
    if (!accordionTriggers.length) return;

    accordionTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const targetId = trigger.getAttribute('aria-controls');
        const content = document.getElementById(targetId);
        const icon = trigger.querySelector('.accordion-icon');
        const item = trigger.closest('.accordion-item');

        // Close other open accordions for clean single-focus accordion UX
        accordionTriggers.forEach(function(otherTrigger) {
          if (otherTrigger !== trigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
            const otherTarget = document.getElementById(otherTrigger.getAttribute('aria-controls'));
            const otherIcon = otherTrigger.querySelector('.accordion-icon');
            const otherItem = otherTrigger.closest('.accordion-item');

            if (otherTarget) otherTarget.classList.add('hidden');
            if (otherIcon) otherIcon.classList.remove('rotate-180');
            if (otherItem) otherItem.classList.remove('is-active');
          }
        });

        // Toggle current
        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          if (content) content.classList.add('hidden');
          if (icon) icon.classList.remove('rotate-180');
          if (item) item.classList.remove('is-active');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          if (content) content.classList.remove('hidden');
          if (icon) icon.classList.add('rotate-180');
          if (item) item.classList.add('is-active');
        }
      });
    });
  }

  window.GinaAccordion = { init: initAccordion };
})();
